import axios from 'axios';
import { Dispatch } from 'redux';
import { IUser } from 'models/IUser';
import { GlobalActionTypes, GlobalActions } from 'store/global/types';
import { NavigateFunction } from 'react-router-dom';
import apiService from 'services/apiService';
import { AuthActionTypes } from 'store/auth/types';
import { loadMe } from 'store/auth/actions';

export const registerUserWithEmail =
  (
    formData: Partial<IUser> & { token: string },
    navigate: NavigateFunction,
    executeRecaptcha: (action?: string) => Promise<string>,
  ) =>
  async (dispatch: Dispatch<GlobalActions> | any) => {
    const { email, password } = formData;
    dispatch({ type: GlobalActionTypes.LOADING });
    try {
      await axios.post('/auth/register', formData);
      const token = await executeRecaptcha('login');
      localStorage.setItem('recaptcha_token', token);
      const response = await apiService.post('/auth/login', { email, password, token });
      dispatch({
        type: AuthActionTypes.LOGIN_WITH_EMAIL_SUCCESS,
        payload: { token: response.data.token, me: response.data.me },
      });

      dispatch({ type: GlobalActionTypes.LOADING });
      await dispatch(loadMe);
      dispatch({
        type: GlobalActionTypes.SUCCESS_LOAD,
      });
      navigate('/users/identity_verification');
    } catch (err: any) {
      dispatch({
        type: GlobalActionTypes.MESSAGE_FAIL,
        payload: { error: err?.response?.data.message || err.message },
      });
    }
  };
